import { render, staticRenderFns } from "./IntegrationCards.vue?vue&type=template&id=652e68bc&"
import script from "./IntegrationCards.vue?vue&type=script&lang=ts&"
export * from "./IntegrationCards.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationCards.vue?vue&type=style&index=0&id=652e68bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports